export enum MqttQos {
    none = 0,
    atLeastOnce = 1,
    exactlyOnce = 2,
}
